import api from './api'

export default {
  sendEmailVerification(login) {
    return api.post('/email-verification/send-email', { login })
  },

  verifyEmail({ login, token }) {
    return api.post('/email-verification', { login, token })
  },

  updateCurrentUser(body) {
    return api.patch('/current-user', body)
  },
}
